import { useStaticQuery, graphql } from 'gatsby';

export const useLandingData = () => {
  const { datoCmsMathxHomePage } = useStaticQuery(
    graphql`
      query homePageQuery {
        datoCmsMathxHomePage {
          primoBloccoTitolo
          primoBloccoParagrafo
          primoBloccoPulsante
          topVideoFallbackImage{
            url
          }
          topVideo{
            url
          }
          topVideoUrl
          secondoBloccoTitolo
          centralVideo{
            url
          }
          centralVideoFallbackImage{
            url
          }
          centralVideoUrl
          centralText
          titoloCarosello
          introCarosello
          socialFacebook{
            alt
            title
            url
          }
          socialTwitter{
            alt
            title
            url
          }
          titoloArgomento1
          titoloArgomento2
          titoloArgomento3
          titoloArgomento4
          contenutoArgomento1
          contenutoArgomento2
          contenutoArgomento3
          contenutoArgomento4
          immagineFallbackArgomento1 {
            url
            alt
            title
          }
          videoArgomentoUrl1
          immagineArgomento1 {
            url
            alt
            title
          }
          immagineFallbackArgomento2 {
            url
            alt
            title
          }
          videoArgomentoUrl2
          immagineArgomento2 {
            url
            alt
            title
          }
          immagineFallbackArgomento3 {
            url
            alt
            title
          }
          videoArgomentoUrl3
          immagineArgomento3 {
            url
            alt
            title
          }
          immagineFallbackArgomento4 {
            url
            alt
            title
          }
          videoArgomentoUrl4
          immagineArgomento4 {
            url
            alt
            title
          }
          corsoPrezzi
          corsoPresentazione
          ctaLabel
          destinazionePulsanteCta
          formContatti {
            formContattiTitolo
            formContattiTestoIntroduttivo
            formContattiFormTesto
            formContattiFormTitolo
            formContattiLabelCta
            formContattiTitleModal
            formContattiButtons {
              style
              buttonHref
              buttonLabel
              buttonFunction
            }
          }
          menu {
            menuUrl
            menuTitoloVisualizzato
          }
          tagLine
        }
      }
  `,
  );

  return datoCmsMathxHomePage;
};
